var _defs, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21,7.5H16.5V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V13.5a3,3,0,0,0,3,3H7.5V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V10.5A3,3,0,0,0,21,7.5ZM3,15a1.5,1.5,0,0,1-1.5-1.5V3A1.5,1.5,0,0,1,3,1.5H13.5A1.5,1.5,0,0,1,15,3V13.5A1.5,1.5,0,0,1,13.5,15Zm18-1.43H19.2a12.19,12.19,0,0,1-2.43,4.14A10.7,10.7,0,0,0,21,19.63,7.09,7.09,0,0,0,20.06,21a10.65,10.65,0,0,1-4.4-2.24A13.14,13.14,0,0,1,11.33,21a7.35,7.35,0,0,0-.83-1.3,11.59,11.59,0,0,0,4.15-1.93,10.69,10.69,0,0,1-.94-1.27h0A3,3,0,0,0,15.12,16c.19.25.4.5.62.74a10,10,0,0,0,1.91-3.2H16.5V12H21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26,4.25l-2.8,7.5H6.13l.65-1.93H9.56l.65,1.93H12L9.18,4.25ZM7.12,8.71l1-3h.07l1,3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.6fee3a79.svg";
export { ForwardRef as ReactComponent };